import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH = 'M22.4071 8.38286H56V35.456H22.4071V44L0 21.9194L22.4071 0V8.38286Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 44

/**
 * Arrow Left shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const ArrowLeftShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default ArrowLeftShape
